module.exports = "<section id=\"about-us\" class=\"card  section feature-box mt-4\">\n    <div class=\"card-block\">\n      <div>\n        <h1 class=\"card-title section-heading wow fadeIn\" data-wow-delay=\"0.2s\">{{sectionTitle}}</h1>\n        <!--Section sescription-->\n        <div class=\"card-text section-description lead wow fadeIn\" data-wow-delay=\"0.2s\">\n          <p>{{ sectionDescription }}</p>\n        </div>\n\n      </div>\n    </div>\n\n</section>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/landingpage/sections/aboutus/aboutus.component.html
// module id = 223
// module chunks = 1